import { AdminLayout } from '../../components/layout/AdminLayout';
import { FileManager } from '../../components/admin';

export function AdminFileManagerPage() {
  return (
    <AdminLayout>
      <div className="p-0 sm:p-0">
        <FileManager />
      </div>
    </AdminLayout>
  );
}
